import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { BudgetNoCollectedDataChip } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetNoCollectedDataChip";
import { TrendChip } from "@/components/common/chips/TrendChip";
import { money } from "@/utils/numeral/money";

export const BudgetDetailsHistoryVarianceCostBasedCell: FC<
  CustomCellRendererProps<ProcessedHistoryData>
> = ({ data }) => {
  if (typeof data?.budgetVarianceCostBased === "string") {
    return <BudgetNoCollectedDataChip />;
  }

  return (
    <TrendChip
      hideIcon
      hidePercentIcon
      value={data?.budgetVarianceCostBased}
      title={money(data?.budgetVarianceCostBased)}
    />
  );
};
